import { getUserInfo } from '@/features/homepage/api/ApiGetUserInfo';
import { Fragment, useEffect, useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import logoCCBJI from "@/assets/img/2800_CCBJI_Logo.bmp";
import logoFVJ from "@/assets/img/2801_FVJ_Logo.bmp";
import { COMPANY_CODE } from "@/constant";

// SCN013

const RegistEmailExpirePage = () => {
    const [loading, setLoading] = useState(true);
    const [vkorg, setVkorg] = useState(logoCCBJI);
    const location = useLocation();
    const navigate = useNavigate();

    useEffect(() => {
        setLoading(true);
        // Fetch user info to determine which company logo to show
        const fetchData = async () => {
            const dataInput = {
                login_id: location.state?.id,
                password: location.state?.dealer_cd,
                token: "null"
            };

            const company_info = location.state?.company_info;

            // If missing required info, redirect to login
            // if (!dataInput.login_id && !dataInput.password || !company_info) {
            //     navigate("/login");
            // }

            try {
                // API call for user info
                if (dataInput.login_id && dataInput.password) {
                    const response = await getUserInfo(dataInput);
                    if (response.data) {
                        // Set logo based on company code
                        setVkorg(response.data.vkorg);
                        if (response.data.vkorg === COMPANY_CODE.FVJ) {
                            setVkorg(logoFVJ);
                        } else {
                            setVkorg(logoCCBJI);
                        }
                    }
                } else {
                    // Set logo based on company code
                    (company_info === COMPANY_CODE.FVJ) ? setVkorg(logoFVJ) : setVkorg(logoCCBJI)
                }

            } catch (error) {
                // Hide spinner on error
                setLoading(false);
            } finally {
                // Hide spinner on error
                setLoading(false);
            }

        }
        fetchData();
    }, [location.state?.dealer_cd, location.state?.id, navigate, location.state?.company_info]);


    // Handler: navigate to login page when logo clicked
    const backToLogin = () => {
        navigate('/login');
    }

    // UI Rendered
    return (
        <Fragment>
            <div style={{ display: loading ? 'none' : 'block' }}>
                <nav className="navbar navbar-expand-lg navbar-light justify-content-start bg-white p-0" >
                    <ul className="navbar-nav ms-auto">
                        <li className="nav-item d-flex justify-content-around" onClick={backToLogin} style={{ height: '71px' }}>
                            <img className="m-1" src={vkorg} alt="Logo 1" style={{ height: '90%' }} />
                        </li>
                    </ul>
                </nav >
                <div className="container-fluid background-cover-external">
                    <ol className="breadcrumb">
                        <li className="breadcrumb-item active">登録リンク期限切れ</li>
                    </ol>
                    <div className="jumbotron">
                        <div className="section">
                            <div className="card-body" style={{ minHeight: '45vh' }}>
                                <ul className="list-group list-group-flush">
                                    <li className="list-group-item">
                                        <p>
                                            <span className='text-coca'>リンクが無効または期限切れです。</span> <br />
                                            <span><Link className="text-primary" to="/login"><u>ログイン</u></Link>からメールアドレス登録をやり直してください。</span>
                                        </p>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </Fragment>
    );
};

export default RegistEmailExpirePage;
